// extracted by mini-css-extract-plugin
export default {"Active":"DirectorStatus_Active__ACgrj","Former":"DirectorStatus_Former__EDgi2"};